<agr-form-dialog
  [formGroup]="formGroup"
  [data]="data"
  (confirm)="confirm()"
  (cancel)="cancel()"
  class="flex--gutter-container"
>
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'cropName' | translate }}</mat-label>
      <input
        type="text"
        [placeholder]="'cropName' | translate"
        matInput
        formControlName="cropId"
        [matAutocomplete]="cropAutocomplete"
        data-test="edit-cropId"
      />
      <mat-autocomplete #cropAutocomplete="matAutocomplete" [displayWith]="displayCrop()">
        @for (option of filteredCrops(); track option) {
          <mat-option [value]="option?.id" data-test="edit-cropfield-crop-option">
            {{ option.agrifirmCrop.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-select
        formControlName="calendarYear"
        [placeholder]="'year' | translate"
        data-test="overview-calendarYear"
      >
        @for (year of availableCropYears; track year) {
          <mat-option [value]="year" data-test="overview-cropYear-options">
            {{ year }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'cultivationMonthsFrom' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        placeholder="{{ 'cultivationMonthsFrom' | translate }}"
        formControlName="cultivationMonthsFrom"
        data-test="edit-cultivationMonthsFrom"
      />
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'cultivationMonthsUntil' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        placeholder="{{ 'cultivationMonthsUntil' | translate }}"
        formControlName="cultivationMonthsUntil"
        data-test="edit-cultivationMonthsUntil"
      />
    </mat-form-field>
  </div>
  <div class="flex--row flex--gutter">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'planetProofNormInKg' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        placeholder="{{ 'planetProofNormInKg' | translate }}"
        formControlName="norm"
        data-test="edit-cropSetting"
      />
    </mat-form-field>
  </div>
</agr-form-dialog>
